import { Context, Effect } from "effect";
import type { Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { QueueAction, QueueSettlement, QueueSnapshot } from "./model.ts";
export class QueueBrowserIo extends Context.Service<QueueBrowserIo, {
  readonly prompt: Effect.Effect<string | null, ResourceFailure>;
  readonly confirmPurge: (queueName: string) => Effect.Effect<boolean, ResourceFailure>;
}>()("workerstation/frontend/QueueBrowserIo") {}
export interface QueueSession { readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<QueueSnapshot>>; readonly settlements: Effect.Effect<readonly QueueSettlement[]>; readonly dispatch: (action: QueueAction) => Effect.Effect<void>; }
export class QueueSessions extends Context.Service<QueueSessions, { readonly open: Effect.Effect<QueueSession, never, Scope.Scope>; }>()("workerstation/frontend/QueueSessions") {}
